<template>
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" ref="table" :defaultLoadData="false"></grid-table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "./Itable";
    
  export default {    
    name: 'ViolationRecord',
    components: {
      GridTable
    },
    data () {
      return {
        url: '/wf/violations/list',
        queryParams: {
          column: 'violationsTime',
          order: 'desc',
        },
        columns: [{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'设备',
            align:"center",
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title:'取水人',
            align:"center",
            sorter: true,
            dataIndex: 'consumerUserId_dictText'
          },
          {
            title:'用水企业',
            align:"center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title:'违规类型',
            align:"center",
            sorter: true,
            dataIndex: 'violationsType_dictText'
          },
          {
            title:'违规时间',
            align:"center",
            sorter: true,
            dataIndex: 'violationsTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'次数',
            align:"center",
            dataIndex: 'count'
          },
          {
            title:'是否处理',
            align:"center",
            dataIndex: 'dealflag',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['dealflag'], text) : ''),
          }]        
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      userInfo() {
        return this.$store.getters.userInfo
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      
    },
    mounted () {
      this.queryData();
    },
    // 方法集合
    methods: {
      queryData () {
        //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
        if(!!this.userInfo.thirdAccount){
          this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
          this.queryParams.corpId =  this.userInfo.corpIds;
        }
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>